import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
  },
  message: {
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    fontWeight: '500',
    fontSize: 18,
    color: 'grey.800',
  },
  buttonContainer: {
    display: 'flex',
    columnGap: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
